module.exports = __webpack_public_path__ + "static/img/American Credit V-6_logo and trademark_only.bcca72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American Credit V-6_logo and trademark_only.png
// module id = 1522
// module chunks = 5